<div class="grid mx-3">
  <div class="col-12">
    <p-table dataKey="fundraiserId"
             [value]="fundraisers"
             styleClass="datatable-sm"
             [scrollable]="true"
             scrollHeight="400px">
      <ng-template pTemplate="header">
        <tr>
          <th>Fundraiser ID</th>
          <th>Bundler ID</th>
          <th>Name</th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-fundraiser>
        <tr>
          <td>
            <a href="javascript:void(0)" (click)="navigateToFundraiser(fundraiser.fundraiserId)">
              {{ fundraiser.fundraiserId }}
            </a>
          </td>
          <td>{{ fundraiser.bundlerId }}</td>
          <td style="text-align: left;">{{ fundraiser.name }}</td>
          <td>
            <!--<button pButton icon="pi pi-trash" class="p-button-danger p-button-text" (click)="confirmDeleteFundraiser(fundraiser.fundraiserId)"></button>-->
            <rc-generic-button label="Delete" iconImg="trash" iconColor="red-light" [isIconOnly]="true" data-cy="btn-Delete" [classes]="['table-action-btn']" (clickHandler)="confirmDeleteFundraiser(fundraiser.fundraiserId)" [disabled]="isReadOnlyMode" />
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" *ngIf="fundraisers.length === 0">
        <tr>
          <td [attr.colspan]="4" style="text-align: center;">
            There are no fundraisers for this donation.
          </td>
        </tr>
      </ng-template>
    </p-table>

    <div class="flex justify-content-end mt-2">
      <rc-generic-button label="Add New Fundraiser" iconImg="plus" borderStyle="text-only" level="secondary" size="small" (click)="openAddFundraiserDialog()" [disabled]="isReadOnlyMode" />
    </div>
  </div>
</div>

<!-- Add Fundraiser MODAL -->
<p-dialog header="Add Fundraiser"
          [(visible)]="showAddFundraiserDialog"
          [modal]="true"
          [closable]="false"
          [maximizable]="true"
          draggable="false"
          styleClass="p-dialog-static p-dialog-sm fadeinright animation-duration-300">
  <div class="formgrid">
    <div class="field">
      <label class="field-label required">Fundraiser</label>
      <p-autoComplete [suggestions]="fundraiserSuggestions"
                      (completeMethod)="searchFundraisers($event)"
                      [(ngModel)]="selectedFundraiser"
                      field="text"
                      placeholder="Type to Search">
      </p-autoComplete>
    </div>
  </div>

  <div class="imported-dialog-footer">
    <p-button label="Cancel"
              type="button"
              [text]="true"
              (click)="showAddFundraiserDialog = false">
    </p-button>
    <p-button label="Save"
              severity="primary"
              type="button"
              [disabled]="!selectedFundraiser || isReadOnlyMode"
              (click)="addFundraiser()">
    </p-button>
  </div>
</p-dialog>

<!-- confirmation dialog -->
<p-dialog header="Confirm Action"
          [(visible)]="showDeleteDialog"
          [modal]="true"
          [closable]="false"
          styleClass="p-confirm-dialog">

  <p>Are you sure you want to delete this fundraiser?</p>
  
  <p-footer>
    <button pButton type="button" class="p-button-outlined" label="Cancel" (click)="closeDeleteDialog()"></button>
    <button pButton type="button" label="Delete" (click)="deleteFundraiser()" [disabled]="isReadOnlyMode"></button>
  </p-footer>
</p-dialog>
